import { Bell, Inbox, Mail, MessageSquare } from 'lucide-react';
import { ContextHero, DataCard, PageContainer, SectionTitle } from '@/components/design-system';

export function CommunicationPage(): JSX.Element {
  return (
    <PageContainer>
      <div className="space-y-6">
        <ContextHero
          variant="marketing"
          icon={<MessageSquare className="h-5 w-5" />}
          title="Communication"
          subtitle="Module Communication — bientôt disponible. Inbox unifiée, emails sortants programmés, rappels automatiques."
        />
        <SectionTitle>Aperçu modules à venir</SectionTitle>
        <div className="grid gap-4 md:grid-cols-3">
          <DataCard
            title="Inbox unifiée"
            subtitle="Email + WhatsApp + SMS"
            trailing={<Inbox className="h-4 w-4 text-slate-400" />}
          >
            <p className="text-sm text-slate-600">
              Centralise les conversations clients, attribue à un commercial, statut traité/à
              relancer.
            </p>
          </DataCard>
          <DataCard
            title="Emails programmés"
            subtitle="Templates + envois différés"
            trailing={<Mail className="h-4 w-4 text-slate-400" />}
          >
            <p className="text-sm text-slate-600">
              Templates relance acompte/solde, envoi nuit, A/B testing.
            </p>
          </DataCard>
          <DataCard
            title="Rappels automatiques"
            subtitle="Cron + escalade direction"
            trailing={<Bell className="h-4 w-4 text-slate-400" />}
          >
            <p className="text-sm text-slate-600">
              Relance J+7 / J+15 / mise en demeure J+30, log automatique dans la fiche tier.
            </p>
          </DataCard>
        </div>
      </div>
    </PageContainer>
  );
}
